import { BaseEntity } from "#sitis/internal/models/concrete/BaseEntity";
export class ContentMenuItem extends BaseEntity {
  index;
  navId;
  langId;
  isHidden;
  isHome;
  title;
  titleTag;
  alias;
  path;
  description;
  children;
  hasChildren;
  imageId;
  constructor(data) {
    super(data);
    this.index = data.index;
    this.navId = data.nav_id;
    this.langId = data.lang_id;
    this.isHome = data.is_home;
    this.isHidden = data.is_hidden;
    this.title = data.title;
    this.titleTag = data.title_tag;
    this.alias = data.alias;
    this.path = data.path;
    this.description = data.description;
    this.hasChildren = data.has_children;
    this.children = data.children.map((c) => new ContentMenuItem(c).toJSON());
    this.imageId = data?.image_id;
  }
  toJSON() {
    return { ...this };
  }
}
export class ContentMenu {
  id;
  name;
  alias;
  items;
  constructor(data) {
    this.id = data.id;
    this.name = data.name;
    this.alias = data.alias;
    this.items = data.items.map((i) => new ContentMenuItem(i).toJSON());
  }
  toJSON() {
    return { ...this };
  }
}
export class MenuTreeItem {
  id;
  name;
  slug;
  label;
  items;
  isCurrent;
  parentId;
  count;
  constructor({ id, name, slug, label, items, isCurrent, parentId, count }) {
    this.id = id;
    this.name = name;
    this.slug = slug;
    this.label = label || name;
    this.items = items || [];
    this.isCurrent = isCurrent;
    this.parentId = parentId || null;
    this.count = count || 0;
  }
}
